export default "__VITE_ASSET__fb3fa0c1__"